export default "__VITE_ASSET__BPSXzG$n__"